/** Coordinates one refresh per page and, when a shared lock is supplied, per browser origin. */
export const createRefreshCoordinator = ({
  readGeneration,
  recordRefresh,
  refresh,
  withLock,
}: {
  readGeneration: () => string | null;
  recordRefresh: () => void;
  refresh: () => Promise<void>;
  withLock: (work: () => Promise<void>) => Promise<void>;
}) => {
  let inFlight: Promise<void> | null = null;

  return (observedGeneration: string | null): Promise<void> => {
    if (inFlight) return inFlight;
    inFlight = withLock(async () => {
      // A different tab refreshed the shared cookie after the request was sent.
      if (readGeneration() !== observedGeneration) return;
      await refresh();
      recordRefresh();
    }).finally(() => {
      inFlight = null;
    });
    return inFlight;
  };
};
